import React, { memo, useMemo } from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { ORDER_PAY_WAITER_SUCCESS_CONSTANTS, ORDER_PAY_WAITER_FAILURE_CONSTANTS } from "./constant";
import {
    HeadingTitleContainer,
    DescriptionContainer,
    ContentContainer,
    ButtonContainer,
    FlexCta,
    ImageContainer,
} from "./styled";
import { IPayWaiterContentProps, IPayWaiterCTA } from "./types";

const PayWaiterContent = memo(({ onPrimaryClick, isError }: IPayWaiterContentProps) => {
    const constants = isError
        ? ORDER_PAY_WAITER_FAILURE_CONSTANTS
        : ORDER_PAY_WAITER_SUCCESS_CONSTANTS;

    const ctas: IPayWaiterCTA[] = useMemo(
        () => [
            {
                text: constants.PRIMARY_BUTTON_TEXT,
                buttonType: "primary",
                onClick: onPrimaryClick,
            },
        ],
        [constants.PRIMARY_BUTTON_TEXT, onPrimaryClick]
    );

    return (
        <ContentContainer>
            <ImageContainer isError={isError}>
                <Image
                    src={constants.IMAGE}
                    alt={constants.IMAGE_ALT}
                    cloudinaryHeight={constants.ICON_HEIGHT * 2}
                    cloudinaryWidth={constants.ICON_WIDTH * 2}
                    height={String(constants.ICON_HEIGHT)}
                    width={String(constants.ICON_WIDTH)}
                />
            </ImageContainer>

            <HeadingTitleContainer isError={isError}>
                <Text variant="V2.heading1.neutral.black" color="text_Highest_Emphasis">
                    {constants.TITLE}
                </Text>
            </HeadingTitleContainer>

            <DescriptionContainer>
                <Text variant="V2.body1.neutral.regular" color="text_Low_Emphasis">
                    {constants.SUBTITLE}
                </Text>
            </DescriptionContainer>

            <ButtonContainer>
                {ctas?.map((cta) => (
                    <FlexCta key={cta?.text}>
                        <SuperButton
                            buttonType={cta.buttonType || "primary"}
                            buttonSize="large"
                            onClick={cta.onClick}
                        >
                            {cta.text}
                        </SuperButton>
                    </FlexCta>
                ))}
            </ButtonContainer>
        </ContentContainer>
    );
});

PayWaiterContent.displayName = "PayWaiterContent";

export default PayWaiterContent;
